import { render, staticRenderFns } from "./DynamicColumnMenu.vue?vue&type=template&id=191f4bc4"
import script from "./DynamicColumnMenu.vue?vue&type=script&lang=ts"
export * from "./DynamicColumnMenu.vue?vue&type=script&lang=ts"
import style0 from "./DynamicColumnMenu.vue?vue&type=style&index=0&id=191f4bc4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports